import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactDom, { unmountComponentAtNode, createPortal } from "react-dom";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import VGPopUp from "../Controls/VGPopUp";
import { Form } from "react-bootstrap";
import { ResponseCode, utils, LoginUserType } from "../../utils/Utils";
import { AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxDelete } from "../Common/AsyncAjaxService";
import Loader from "../Common/Loader";
import store from '../../app/store'
import "./Style.scss";
import useGenerateToken from "components/Hook/useGenerateToken";

const EditCategoriesStylePopup = (props) => {
    const newCategoryName = useRef(null);
    const { ReactBusinessId, ReactUserID } = store.getState().Business;

    const VagaroAPIEnum = {
        GetStyleCategory: "style/getcategory",
        AddEditCategory: "style/addeditbusinesstype",
        DeleteCategory: "style/deletecategory",
    };

    const allcategory = props.category;
    const allsubcategory = props.subCategory;
    const isBuilderPage = props.isBuilderPage;

    const [isValidCategoryId, setIsValidCategoryId] = useState(true);
    const [isValidCategory, setIsValidCategory] = useState(true);
    const [businessTypeId, setBusinessTypeId] = useState('');

    const [isValidNewSubCategoryName, setIsValidNewSubCategoryName] = useState(true);
    const [isValidpandingInput, setIsValidpandingInput] = useState(true);
    const [newSubCategoryName, setNewSubCategoryName] = useState("");

    const [subCategoryList, setSubCategoryList] = useState([]);
    const [subCategoryId, setSubCategoryId] = useState("");
    const [subCategoryname, setSubCategoryname] = useState("");
    const [addEditCategory, setAddEditCategory] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isEnterCategoryName, setIsEnterCategoryName] = useState(true);

    useEffect(() => {
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to edit category.", "OpenDialog");
        }
        else {
            if (props.CategoryID != "" && props.CategoryID.length > 0) {
                GetSubCategory(props.CategoryID[0]);
                setBusinessTypeId(props.CategoryID[0]);
            }
            else {
                GetSubCategory("")
            }

            newCategoryName.current.focus();
        }
    }, []);


    const GetSubCategory = async (CategoryID) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to get category.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                setLoading(true);
                setBusinessTypeId(CategoryID);
                await AsyncAjaxGet(
                    VagaroAPIEnum.GetStyleCategory,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null) {
                                    if (CategoryID !== "") {
                                        setSubCategoryList(data.data.data);
                                    }
                                    else {
                                        setSubCategoryList(data.data.data);
                                        allsubcategory = data.data.data;
                                    }

                                }
                                else {
                                    setSubCategoryList([]);
                                }
                            }
                            setLoading(false);
                        }
                        catch (error) {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Get Category SubCategory",
                                null,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Category SubCategory",
                            null,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    };

    const SaveCategory = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to save categories.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                let businessTypeids = addEditCategory.map((data) => data.id).join(",")
                if (businessTypeId === "" || newSubCategoryName.trim() !== "" || businessTypeids === "") {
                    if (businessTypeId === "") {
                        setIsValidCategoryId(false);
                    }
                    else {
                        setIsValidCategoryId(true);
                    }
                    if (newSubCategoryName.trim() !== "") {
                        setIsValidpandingInput(false)
                    }
                    if (addEditCategory.length === 0 && newSubCategoryName.trim() === "") {
                        PopupClose();
                    }
                    return;
                }
                if (subCategoryId === "") {
                    var IsExistsCategoryName = allsubcategory.filter(
                        (col) => col.name.toLowerCase() === newSubCategoryName.toLowerCase()
                    );
                    if (IsExistsCategoryName.length > 0) {
                        setIsValidCategory(false)
                        return;
                    }
                }
                else {
                    var IsExistsCategoryName = allsubcategory.filter(
                        (col) => col.name.toLowerCase() === newSubCategoryName.toLowerCase() && col.id !== subCategoryId
                    );
                    if (IsExistsCategoryName.length > 0) {
                        setIsValidCategory(false)
                        return;
                    }
                }

                setLoading(true);
                const Requestdata = {};
                Requestdata.Id = addEditCategory.map((data) => data.id).join(",");
                Requestdata.Name = addEditCategory.map((data) => data.name).join(",");
                Requestdata.ParentCategoryId = businessTypeId;
                await AsyncAjaxPost(
                    VagaroAPIEnum.AddEditCategory,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                    setNewSubCategoryName("");
                                    setSubCategoryId("");
                                    setBusinessTypeId("");
                                    if (businessTypeId != "") {
                                        GetSubCategory(businessTypeId);
                                    }
                                    else {
                                        GetSubCategory("")
                                    }
                                    props.onClose()
                                    if (isBuilderPage === false) {
                                        props.categorySubCategoryBinding(props.selectionCategoryId.current, props.selectionSubCategoryId.current);
                                        PopupClose();
                                    }
                                    else {
                                        PopupClose();
                                    }
                                }
                                else {
                                    setLoading(false);
                                }
                            }
                            else {
                                setLoading(false);
                            }
                        }
                        catch (error) {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Save/Edit New Sub Category",
                                Requestdata,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Save/Edit New Sub Category",
                            Requestdata,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    };

    const RemoveSubCategoryConfirmationPopup = async (SubCategoryId, SubCategoryName) => {
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to deactivate style.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"RemoveSubCategoryConfirmationPopup"}
                    show={true}
                    onHide={PopupSecondClose}
                    title={"Delete Category"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">
                            <p>Are you sure you want to remove category?</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupSecondClose()}>Cancel</button>
                            <button className="w-button w-button-destructive-outline" onClick={() => RemoveSubCategory(SubCategoryId, SubCategoryName)}>Delete Category</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog2"));
        }
    }
    const RemoveSubCategory = async (SubCategoryId, SubCategoryName) => {
        const access_token = await useGenerateToken(props.dispatch);
        var catagorys = subCategoryList.filter((data) => (data.id == 0 && data.name == SubCategoryName));
        if (catagorys.length > 0) {
            var cat = subCategoryList.filter((data) => (data.name != SubCategoryName));
            var req = addEditCategory.filter((data) => (data.name != SubCategoryName));
            setAddEditCategory(req);
            setSubCategoryList(cat);
            setNewSubCategoryName("");
            setSubCategoryname("");
            setSubCategoryId("");
            PopupSecondClose();
            return;
        }
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to edit categories.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if (SubCategoryId != "") {
                    setLoading(true);
                    await AsyncAjaxDelete(
                        VagaroAPIEnum.DeleteCategory + "?categoryId=" + SubCategoryId,
                        access_token,
                        function onSuccess(data) {
                            try {
                                if (
                                    data != null &&
                                    data.data != null &&
                                    data.data.responseCode == ResponseCode.Success
                                ) {
                                    if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                        setNewSubCategoryName("");
                                        setSubCategoryId("");
                                        GetSubCategory(businessTypeId);
                                        props.onDelete(SubCategoryId)
                                        if (isBuilderPage === false) {
                                            PopupSecondClose();
                                            props.categorySubCategoryBinding(props.selectionCategoryId.current, props.selectionSubCategoryId.current);
                                        }
                                        else {
                                            PopupSecondClose();
                                        }
                                    }
                                    else {
                                        setLoading(false);
                                    }
                                }
                                else {
                                    setLoading(false);
                                }
                            }
                            catch (error) {
                                setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Remove Sub Category",
                                    SubCategoryId,
                                    ""
                                );
                            }
                        },
                        function OnError() {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Remove Sub Category",
                                SubCategoryId,
                                ""
                            );
                        }
                    );
                }
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    };

    const categorySelect = (categoryid) => {
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to select categories.", "OpenDialog");
        }
        else {
            setBusinessTypeId(categoryid);
            setAddEditCategory([])
            if (categoryid == "") {
                setIsValidCategoryId(false);
                GetSubCategory("");
            }
            else {
                setIsValidCategoryId(true);
                GetSubCategory(categoryid);
            }
        }
    }

    const AddCategory = (CategoryName) => {
        if (newSubCategoryName === "" || newSubCategoryName === null) {
            setIsEnterCategoryName(false);
            return;
        }

        if (CategoryName.value !== "") {
            if (businessTypeId === "") {
                setIsValidCategoryId(false);
                return
            }
            else {
                setIsValidCategoryId(true);
            }
            var EditCategory = addEditCategory;
            var CategoryList = subCategoryList;
            var catagorys = subCategoryList.filter((data) => (data.id == subCategoryId && data.name == subCategoryname));
            var exist = props.SubCategorys.current.filter((data) => (data.name.trim() == CategoryName.value.trim()));
            if (exist.length === 0) {
                if (catagorys.length > 0) {
                    var editUpdate = addEditCategory.filter((data) => (data.id == subCategoryId && data.name == subCategoryname));
                    CategoryList = CategoryList.map((data) => (data.id == subCategoryId && data.name == subCategoryname) ? { ...data, name: CategoryName.value } : data);
                    if (editUpdate.length > 0) {
                        EditCategory = EditCategory.map((data) => (data.id == subCategoryId && data.name == subCategoryname) ? { ...data, name: CategoryName.value } : data);
                    } else {
                        EditCategory.push({
                            id: subCategoryId,
                            type: "update",
                            name: CategoryName.value,
                            parentCategoryId: businessTypeId
                        })
                    }
                } else {
                    EditCategory.push({
                        id: "0",
                        type: "Add",
                        name: CategoryName.value,
                        parentCategoryId: businessTypeId
                    })
                    CategoryList.push({
                        id: "0",
                        oldName: "Add",
                        name: CategoryName.value,
                        parentCategoryId: businessTypeId

                    })
                }
                setSubCategoryList(CategoryList);
                setAddEditCategory(EditCategory);
                setNewSubCategoryName("");
                setSubCategoryname("");
                setSubCategoryId("");
                setIsValidCategory(true)
                setIsValidpandingInput(true)
            } else {
                setIsValidCategory(false)
            }
        }
    }

    const SubCategoryValidation = (CategoryName) => {
        setIsEnterCategoryName(true)
        setIsValidNewSubCategoryName(true);
        const result = CategoryName.replace(/[#%*<>|\/]*/g, "");
        setNewSubCategoryName(result);
        setIsValidCategory(true);
        if (CategoryName === "") {
            setSubCategoryname("")
            setIsValidpandingInput(true);
        }
    }

    const EditSubCategory = (SubCategoryId, SubCategoryName, parentCategoryId) => {
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to edit category.", "OpenDialog");
        }
        else {
            setSubCategoryId(SubCategoryId);
            setSubCategoryname(SubCategoryName);
            setNewSubCategoryName(SubCategoryName);
            setBusinessTypeId(parentCategoryId);
            setIsValidNewSubCategoryName(true);
            setIsValidpandingInput(true);
            setIsValidCategory(true);
            setIsEnterCategoryName(true);

        }
    }

    const EditCategoriesStyleBody = () => {
        return (
            <div className="form-content">
                {isLoading && <Loader />}
                <span>Add a new category by selecting business type and creating a category name.</span>
                <br />
                <br />
                {/* <Form> */}
                    {/* <Form.Group className={`form-row ${!isValidCategoryId && "form-row-invalid"}`}>
                        <Form.Label>Business Type: <span style={{ color: "red" }}>*</span></Form.Label>
                        <div className="vg-wb-select">
                            <Form.Select className="form-control" id="ddlcategory" onChange={(e) => { categorySelect(e.target.value) }} defaultValue={businessTypeId} value={businessTypeId} placeholder="Select Business Type">
                                <option value="">Select Business Type</option>
                                {allcategory.length > 0
                                    && allcategory.map((item) => {
                                        return (
                                            <option value={item.id}>{item.name}</option>
                                        )
                                    }, this)}
                            </Form.Select>
                        </div>
                        {!isValidCategoryId && <Form.Control.Feedback type="invalid">Please select business type</Form.Control.Feedback>}
                    </Form.Group> */}
                    <Form.Group className={`form-row ${(!isValidNewSubCategoryName || !isValidpandingInput || !isValidCategory || !isEnterCategoryName) &&  "form-row-invalid"}`}>
                        <Form.Label>New Category Name: <span style={{ color: "red" }}>*</span></Form.Label>
                        <div className="input-group">
                            <div className="input">
                                <Form.Control type="text" ref={newCategoryName} maxLength={50} placeholder="Enter New Category Name" value={newSubCategoryName} defaultValue={newSubCategoryName} onKeyPress={(e) => e.key === "Enter" && AddCategory(newCategoryName.current)} onChange={(e) => { e.target.value = e.target.value.replace(/[\uD800-\uDFFF].|[\u200D\uFE0F#%*<>|\/]*/g, ""); SubCategoryValidation(e.target.value); }} />
                                {!isValidpandingInput && <Form.Control.Feedback type="invalid">Please {subCategoryname !== "" ? "Update" : "Add"} category</Form.Control.Feedback>}
                                {!isValidNewSubCategoryName && <Form.Control.Feedback type="invalid">Please enter valid category name</Form.Control.Feedback>}
                                {!isValidCategory && <Form.Control.Feedback type="invalid">Category name already exists</Form.Control.Feedback>}
                                {!isEnterCategoryName && <Form.Control.Feedback type="invalid">Please Enter New Category Name</Form.Control.Feedback>}
                            </div>
                            <button type="button" className={"w-button w-button-neutral"} onClick={() => AddCategory(newCategoryName.current)}>{subCategoryname !== "" ? "Update" : "Add"}</button>
                        </div>
                    </Form.Group>
                    {subCategoryList.length > 0 &&
                        <Form.Group className='form-row'>
                            <Form.Label>Current Categories:</Form.Label>
                            <span style={{ marginBottom: "10px", color: "#6D6E6F" }}>Remove a category by deleting it.</span>
                            <div className="tags-input">

                                {subCategoryList.length > 0
                                    && subCategoryList.map((item, index) => (
                                        <span key={index} className="tag category-btn">
                                            <span className='tag-title' onClick={() => EditSubCategory(item.id, item.name, item.parentCategoryId)} value={item.id}>{item.name}</span>
                                            &nbsp;
                                            <span className='tag-close-icon' onClick={() => RemoveSubCategoryConfirmationPopup(item.id, item.name)}><i class="far fa-times"></i></span>
                                        </span>
                                    ))}

                            </div>
                        </Form.Group>
                    }
                {/* </Form> */}
            </div >
        )
    }

    const EditCategoriesStyleFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                <button className="w-button w-button-primary" onClick={() => SaveCategory()}>Save</button>
            </Fragment>
        )
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog1"));
    };

    const PopupSecondClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog2"));
    };

    return createPortal(
        <VGPopUp
            id={"EditCategoriesStylePopup"}
            show={true}
            title={"Edit Categories"}
            onHide={PopupClose}
            size="sm"
            body={EditCategoriesStyleBody()}
            dialogClassName="vg-w480"
            footer={EditCategoriesStyleFooter()}
            isShowFooter={true}
            backdrop={true}
        />,
        document.getElementById("OpenDialog1")
    )
}

export default withAITracking(reactPlugin, EditCategoriesStylePopup);